"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
class Photo extends base_model_1.default {
    constructor(data = {
        id: null,
        url: null,
        ext: null,
        name: null,
        created_at: null,
    }) {
        super(data);
        this.id = defaults_1.defaultString(data.id);
        this.url = defaults_1.defaultString(data.url);
        this.ext = defaults_1.defaultString(data.ext);
        this.name = defaults_1.defaultString(data.name);
        this.created_at = defaults_1.defaultString(data.created_at);
    }
}
exports.default = Photo;
